import t from "./_baseMerge.js";
import m from "./_createAssigner.js";
var a = m(function(e, r, o) {
  t(e, r, o);
});
const g = a;
export {
  g as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/merge.js
// module id = 886
// module chunks = 41